export enum VerificationStatus {
  PHONE_VERIFIED = 'PHONE_VERIFIED',
  IDENTITY_DOCUMENT_VERIFIED = 'IDENTITY_DOCUMENT_VERIFIED',
  NOT_VERIFIED = 'NOT_VERIFIED',
}
